const COLORS = [
    {key: "primary", value: "#C9A24B"},
    {key: "secondary", value: "#142235"},
    {key: "main", value: "#ffffff"},
    {key: "background", value: "#F3F4F6"}
]

export function getColor(key){
    const color = COLORS.find(c => c.key === key)
    return color?.value
}